import React from 'react';
import { Flex, Icon, Label } from '@zeal/web-ui';
import { useTranslation } from 'react-i18next';
import { TitleImage } from '@app/Components/Shared';

export const APP_WEBSITE = import.meta.env.REACT_APP_WEBSITE ?? '';

export default function MobileBanner() {
	const { t } = useTranslation('magicLink');

	return (
		<Flex
			justify="between"
			align="center"
			className="p-4"
			style={{
				background:
					'linear-gradient( 0deg, var(--color-primary-900) 0%, var(--color-primary-500) 100%)',
			}}
		>
			<TitleImage
				style={{
					height: '19.649px',
				}}
			/>
			<a
				target="_blank"
				rel="noreferrer"
				href={APP_WEBSITE + '/merchant-landing'}
				className="z-10"
			>
				<Flex
					align="center"
					justify="center"
					className="cursor-pointer"
					style={{
						gap: '7px',
					}}
				>
					<Label.Mid300 variant="white">{t('learn_more')}</Label.Mid300>
					<Icon iconName="arrowRight" colorVariant="white" variant="regular" />
				</Flex>
			</a>
		</Flex>
	);
}
